import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

import { BaseOrderFieldsFragment, OrderPeriodFieldsFragment } from '../../../../generated/graphql';
import { OrderTypeEnum } from 'src/app/shared/types/order-types';
import { DeleteOrderPeriodGQL } from '../../../graphql/graphql';
import { OrdersService } from '../../orders.service';

@Component({
  selector: 'app-client-need',
  templateUrl: './client-need.component.html',
  styleUrls: ['./client-need.component.scss']
})
export class ClientNeedComponent implements OnInit {
  periods: OrderPeriodFieldsFragment[] = [];
  isIndefinite = false;
  isPeriodError = false;
  periodErrors = {};
  private $form: any;
  @Input() set form(value: FormGroup) {
    this.$form = value;
  }
  get form() { return this.$form; }

  private $orderType: OrderTypeEnum;
  @Input() set orderType(value: OrderTypeEnum) {
    this.$orderType = value;
  }
  get orderType() { return this.$orderType; }

  orderTypes = OrderTypeEnum;

  get formPeriods() {
    return this.form && this.form.get('periods');
  }
  get salaryMatrix() { return this.$form.get('salaryMatrix'); }

  @Input() countryISO: string;

  editOrderId$: string;
  @Input()
  set editOrderId(value: string) {
    if (value) {
      this.editOrderId$ = value;
    }
  }
  get editOrderId() {
    return this.editOrderId$;
  }

  $order: BaseOrderFieldsFragment;
  @Input() set order(val: BaseOrderFieldsFragment) {
    this.$order = val;
    if (val?.orderperiodSet?.length) {
      this.periods = [...val.orderperiodSet];
    }
    if (this.formPeriods) {
      this.formPeriods.setValue(this.periods);
    }
    this.calculateShortage();
  };
  get order(){
    return this.$order;
  }
  @Output() hasError = new EventEmitter<boolean>();
  constructor(
    public ordersService: OrdersService,
    private deletePeriodGQL: DeleteOrderPeriodGQL,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.setPeriod();
    this.calculateShortage();
  }

  onError(v) {
    this.periodErrors[v.index] = v.isError;
    this.isPeriodError = Object.values(this.periodErrors).some(val => val);
    this.hasError.emit(this.isPeriodError);
  }

  fillIndefiniteField(isIndefinite) {
    if (isIndefinite && !this.form.get('indefiniteInfoControl').value) {
      this.form.get('indefiniteInfoControl').setValue(this.translate.instant('INDEFINITE_INFO_TEXT'))
    }
  }

  setPeriod() {

    const addMonth = moment().date() > 15 ? 1 : 0;


    const nextMonthStart = moment().set('date', 1).add( addMonth, 'month');
    const nextMonthEnd = moment().set('date', 1).add( addMonth + 1, 'month').subtract(1, 'days');

    if (this.periods.length === 0 && !this.editOrderId) {
      this.periods.push({
        id: null,
        dateFrom: nextMonthStart.format('YYYY-MM-DD'),
        dateTo: nextMonthEnd.format('YYYY-MM-DD'),
        demand: 1,
        longTerm: false
      });
    }
  }

  onRemove(periodToDelete: OrderPeriodFieldsFragment, e) {
    if (this.periodErrors[e.index] !== undefined) {
      this.periodErrors[e.index] = false;
      this.isPeriodError = Object.values(this.periodErrors).some(val => val);
      this.hasError.emit(this.isPeriodError);
    }
    this.periods = this.periods.filter(e => e !== periodToDelete);
    if (periodToDelete.id) {
      this.deletePeriodGQL.mutate({orderPeriod: periodToDelete.id}).subscribe(
        resp => console.log(resp)
      );
    }
    if (this.formPeriods) {
      this.formPeriods.setValue(this.periods);
    }
    this.calculateShortage();
    if (this.periods.length === 0) {
      this.isIndefinite = false;
      this.fillIndefiniteField(false);
      this.form.get('indefiniteInfoControl').disable();
    }
  }

  addPeriod() {
    this.periods.push({
      id: null,
      dateFrom: moment().format('YYYY-MM-DD'),
      dateTo: moment().add(30, 'days').format('YYYY-MM-DD'),
      demand: 1,
      longTerm: false
    });
    this.formPeriods.setValue(this.periods);
    this.calculateShortage();
  }

  onPeriodChange() {
    this.formPeriods.setValue(this.periods);
    this.calculateShortage();
  }

  calculateShortage() {
    if (!this.editOrderId) {
      this.form.get('shortage')?.setValue(this.periods.map(p => p.demand || 0).reduce((a, b) => a + b, 0));
    }
  }
}
